import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import InputBase from '@material-ui/core/InputBase';
import DnD from '../Commons/Drag_n_Drop';
import useCommonStyles from './styles.js';
import {THEME_PRIMARY_COLOR, THEME_SECONDARY_COLOR} from '../../Constants';
import {devConsolelog} from '../../Utility';
// import DnD from '../Commons/Drag_n_Drop';
import AsyncAutocomplete from '../Commons/asyncAutocomplete';
import Autocomplete from '../Commons/autocomplete';

export const StyledTabs = withStyles(theme => ({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme?.agentTheme?.secondary?.main,  //'transparent',
    '& > div': {
      maxWidth: 40,
      width: '100%',
      // backgroundColor: '#9c27b0', //'#635ee7',
      // color: '#9c27b0'
    },
  },
  selected: {
    color: `${THEME_PRIMARY_COLOR} !important`
  },
  flexContainer: {
    [theme.breakpoints.up("sm")] : {
      justifyContent: 'center'
    }
  }
}))(props => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

export const StyledTabsSecondary = withStyles(theme => ({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.secondary.main,  //'transparent',
    '& > div': {
      maxWidth: 40,
      width: '100%',
      // backgroundColor: '#9c27b0', //'#635ee7',
      // color: '#9c27b0'
    },
  },
  selected: {
    color: `${THEME_SECONDARY_COLOR} !important`
  },
  flexContainer: {
    [theme.breakpoints.up("sm")] : {
      justifyContent: 'center'
    }
  }
}))(props => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

export const StyledTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    // color: '#fff',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: theme?.agentTheme?.card?.foreground,  //`${THEME_PRIMARY_COLOR}`,
    '&:focus': {
      opacity: 1,
      color: theme?.agentTheme?.card?.foreground
    },
  },
  selected: {
    color: `${theme?.agentTheme?.secondary?.main} !important`,
  }
}))(props => <Tab disableRipple {...props} TabIndicatorProps={{ children: <div /> }}/>);

export const StyledRadio = withStyles(theme => ({
  root: {
    color: theme.palette.primary.main,
    '&$checked': {
      color: theme.palette.primary.main,
    },
  },
  checked: {},
}))(props => <Radio color="default" {...props} />);

export const StyledRadioSecondary = withStyles(theme => ({
  root: {
    color: theme.palette.secondary.main,
    '&$checked': {
      color: theme.palette.secondary.main,
    },
  },
  checked: {},
}))(props => <Radio color="default" {...props} />);

export const StyledRadioBlack = withStyles(theme => ({
  root: {
    color: '#212121',
    '&$checked': {
      color: '#212121',
    },
  },
  checked: {},
}))(props => <Radio {...props} />);

export const StyledFabButton = withStyles(theme => ({
  root: {
    backgroundColor: 'black',
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: '#fff'
    },
    // maxWidth: 100
  }
}))(Fab);

export const StyledFabButtonSecondary = withStyles(theme => ({
  root: {

    backgroundColor: 'black',
    color: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: '#fff'
    },
  }
}))(Fab);

export const StyledButton = withStyles(theme => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.text.secondary, 
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.text.secondary,
    },
  }
}))(Button);

export const StyledButtonPrimary = withStyles(theme => ({
  root: {
    backgroundColor: theme?.agentTheme?.primary?.main,
    color: theme.agentTheme.primary.foreground,
    borderRadius:'50px',
    '&:hover': {
      backgroundColor: theme?.agentTheme?.primary?.main,
      color: theme.agentTheme.primary.foreground,
    },

    '&:disabled': {
       color:  theme.agentTheme.primary.foreground,
      backgroundColor:theme.agentTheme.text?.small_text_color
    },

  },
  label: {
    gap:'10px'
  }
}))(Button);

export const StyledButtonSecondary = withStyles(theme => ({
  root: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.text.primary,
    borderRadius:'50px',
    border: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.text.primary,
    },

    '&:disabled': {
      backgroundColor:theme.agentTheme.text?.small_text_color,
      color: theme.palette.text.primary,
    },

  }
}))(Button);

export const StyledButton2 = withStyles(theme => ({
  root: {
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: '#fff'
    }
  }
}))(Button);

export const StyledCheckbox = withStyles(theme => ({
  root: {
    color: theme.palette.primary.main,
    '&$checked': {
      color: theme.palette.primary.main,
    },
  },
  checked: {},
}))(props => <Checkbox color="default" {...props} />);

export const StyledCheckboxSecondary = withStyles(theme => ({
  root: {
    color: theme.palette.secondary.main,
    '&$checked': {
      color: theme.palette.secondary.main,
    },
  },
  checked: {},
}))(props => <Checkbox color="default" {...props} />);

export const StyledCheckboxBlack = withStyles(theme => ({
  root: {
    color: '#212121',
    '&$checked': {
      color: '#212121',
    },
  },
  checked: {},
}))(props => <Checkbox {...props} />);

export const StyledMuiButton = withStyles(theme => ({
  root: {
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    borderColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
}))(Button);

export const StyledMuiButton2 = withStyles(theme => ({
  root: {
    color: theme.palette.getContrastText(theme.palette.secondary.main),
    borderColor: theme.palette.primary.main,
    '&:hover': {
      borderColor: theme.palette.secondary.main,
    },
  },
}))(Button);

export const StyledCircularProgress = withStyles(theme => ({
  root: {
    color: theme.palette.secondary.main
  },
}))(CircularProgress);

export const StyledCircularProgressBlack = withStyles(theme => ({
  root: {
    color: `${THEME_PRIMARY_COLOR}`
  },
}))(CircularProgress);

export const StyledTextField = withStyles(theme => ({
  root: {
  },
}))(TextField);

export const StyledTextFieldBlack = withStyles(theme => ({
  root: {
  },
}))(TextField);



export const StyledTextFieldNew = withStyles(theme => ({
  input: {
  },
}))(InputBase);

export const TextInput = React.memo(props => {
  const commonClasses = useCommonStyles();
return (<FormControl variant="outlined" className={props.styleClass} error={props.errors[props.id] || false}>
   {props.formControlLabel && <InputLabel htmlFor={props.id} className={`${commonClasses.dndFormControlLabel} ${props.labelClass ? props.labelClass : '' }`}>{props.formControlLabel}</InputLabel>}
  <StyledTextFieldBlack {...props} className={`${props.textFieldStyleClass ? props.textFieldStyleClass : ''}`} />
  {
    props.errors[props.id] && <FormHelperText id={props.id}>{props.errors[props.id]}</FormHelperText>
  }
</FormControl>)
})

export const TextInputNew = React.memo(props => {
  const commonClasses = useCommonStyles();
  return (<FormControl error={props.errors[props.id] || false} className={props.styleClass}>
    {props.formControlLabel && <InputLabel htmlFor={props.id} className={`${commonClasses.dndFormControlLabel} ${props.labelClass ? props.labelClass : '' }`}>{props.formControlLabel}</InputLabel>}
    <StyledTextFieldNew {...props} />
    {
      props.errors[props.id] && <FormHelperText id={props.id}>{props.errors[props.id]}</FormHelperText>
    }
  </FormControl>)
})


export const NewInputBase = React.memo((props) => (<FormControl className={props.styleClass} error={props.errors[props.id] || false}>
  <InputBase {...props} />
  {
    props.errors[props.id] && <FormHelperText id={props.id}>{props.errors[props.id]}</FormHelperText>
  }
</FormControl>))

export const DragDropInput = React.memo(props => (<FormControl error={props.errors[props.id] || false} className={props.styleClass}>
  <DnD {...props} />
  {
    props.errors[props.id] && <FormHelperText id={props.id}>{props.errors[props.id]}</FormHelperText>
  }
</FormControl>))

export const CheckboxInput = React.memo(props => (<FormControl classes={{root: props.className}} error={props.errors[props.id] || false}>
  <StyledCheckbox {...props} />
  {
    props.errors[props.id] && <FormHelperText id={props.id}>{props.errors[props.id]}</FormHelperText>
  }
</FormControl>))

export const StyledTypography = withStyles(theme => ({
  root: {
    color: theme.palette.primary.main,
    '&> span': {
      fontSize: '1rem'
    }
  },
}))(Typography);

export const StyledTypographyBlack = withStyles(theme => ({
  root: {
    color: `${theme?.agentTheme?.card?.foreground}`,
    '&> span': {
      fontSize: '1rem'
    }
  },
}))(Typography);

export const StyledSwitch = withStyles(theme => ({
  switchBase: {
    color: theme.palette.secondary.main,
    '&$checked': {
      color: theme.palette.secondary.main,
    },
    '&$checked + $track': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  checked: {},
  track: {},
}))(Switch);

export const AutoAsynccompleteInput = props => {

  return (<FormControl error={props.errors[props.id] || false} className={props.styleClass}>
  {props.formControlLabel && <InputLabel className={props.labelStyleClass} htmlFor={props.id} style={{transform: 'translate(5px, -24px)', fontSize: 12}}>{props.formControlLabel}</InputLabel>}
  <AsyncAutocomplete value={props.value} showOverModal={props.showOverModal || false} {...props} placeholder={props.placeholder} onSearchReqSelect={props.onSearchReqSelect} data={props.data}/>
  {
    props.errors[props.id] && <FormHelperText id={props.id}>{props.errors[props.id]}</FormHelperText>
  }
</FormControl>)}

export const AutocompleteInput = React.memo(props => {
  devConsolelog('formData templates input ', props, props.id)
  return (<FormControl error={props.errors[props.id] || false} className={props.styleClass}>
  {props.formControlLabel && <InputLabel className={props.labelStyleClass} htmlFor={props.id} style={{transform: 'translate(5px, -24px)'}}>{props.formControlLabel}</InputLabel>}
  <Autocomplete value={props.value} {...props} placeholder={props.placeholder} onSearchReqSelect={props.onSearchReqSelect} data={props.data} />
  {
    props.errors[props.id] && <FormHelperText id={props.id}>{props.errors[props.id]}</FormHelperText>
  }
</FormControl>)})
